export const defaultLeaderboardColumns = [
  {
    name: 'Rank',
    title: 'Rank',
    field: 'rank',
    type: 'string',
    canSort: true,
  },
  {
    name: 'Name',
    title: 'Name',
    field: 'name',
    type: 'string',
    canSort: false,
  },
  {
    name: 'Description',
    title: 'Description',
    field: 'description',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
  {
    name: 'Points',
    title: 'Points',
    field: 'points',
    type: 'string',
    canSort: true,
    defaultSort: '',
  },
];
